module.exports = __webpack_public_path__ + "static/media/pinterest.86e4aee0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/site-menu/assets/pinterest.svg
// module id = 16
// module chunks = 0